import React, { FC, useMemo } from 'react'

import { ShippingCountdown, ShippingCountdownProps } from '@Components/Shipping/ShippingCountdown'
import { TimerVisualizationType } from '@Components/UrgencyTimer'
import { Block } from '@Generated/graphql'
import { getJSONFieldValue } from '@Globals/CMS/FieldHelpers'

const getBlockData = (shippingBlock: Block): ShippingCountdownProps => ({
  visualizationType: getJSONFieldValue(shippingBlock.fields || [], 'visualisationType') || TimerVisualizationType.None,
  display: getJSONFieldValue(shippingBlock.fields || [], 'display') || [],
})

interface ShippingBlockProps {
  id?: string
  shippingBlock: Block
}

const ShippingBlock: FC<ShippingBlockProps> = ({ id, shippingBlock }) => {
  const {
    display,
    visualizationType,
  } = useMemo(() => getBlockData(shippingBlock), [shippingBlock])

  return (
    <ShippingCountdown
      display={display}
      id={id}
      visualizationType={visualizationType}
    />
  )
}

export default ShippingBlock
